import React from 'react';
import { Grid } from '@mui/material';
import { EXTENSION_DATA_FORM } from '../constant';
import { useFormContext } from 'react-hook-form';

const ExtensionDataFormWrapper = function ExtensionDataFormWrapper({
  activityType,
  defaultData = {},
  activityTypes,
}) {
  const {
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();
  const FormComponent = EXTENSION_DATA_FORM[activityType];

  if (!FormComponent) {
    return null;
  }
  return (
    <Grid container spacing={2} sx={{ padding: '16px 0px' }}>
      <FormComponent
        errors={errors}
        watch={watch}
        setValue={setValue}
        defaultData={defaultData}
        activityTypes={activityTypes}
      />
    </Grid>
  );
};

export default ExtensionDataFormWrapper;
